export const MENU_ROLE_MUTATION = "MENU_ROLE_MUTATION";
export const MENU_ROLE_RESET_MUTATION = "MENU_ROLE_RESET_MUTATION";
